import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './About.css';
import myPhoto from '../../assets/images/Praveen Kumar.png';

import {
  FaCode,
  FaGraduationCap,
  FaTrophy,
  FaRocket,
  FaLaptopCode,
  FaGlobe,
  FaPalette,
  FaBriefcase,
  FaLightbulb,
  FaBookOpen,
  FaSchool,
  FaBuildingColumns,
  FaCalendarDays,
  FaArrowRight,
  FaPlane,
  FaMusic,
  FaCheck,
  FaHeart
} from 'react-icons/fa6';

// 3D Trophy Vector Graphic
const TrophyIllustration = () => (
  <svg
    width="84"
    height="84"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="achievement-svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="goldGrad" x1="20" y1="15" x2="80" y2="75" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FDE68A" />
        <stop offset="0.45" stopColor="#F59E0B" />
        <stop offset="1" stopColor="#D97706" />
      </linearGradient>
      <linearGradient id="cupRimGrad" x1="26" y1="20" x2="74" y2="24" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FEF3C7" />
        <stop offset="1" stopColor="#F59E0B" />
      </linearGradient>
      <linearGradient id="baseGrad" x1="30" y1="75" x2="70" y2="92" gradientUnits="userSpaceOnUse">
        <stop stopColor="#64748B" />
        <stop offset="1" stopColor="#334155" />
      </linearGradient>
    </defs>
    {/* Pedestal Base */}
    <rect x="28" y="80" width="44" height="12" rx="4" fill="url(#baseGrad)" />
    <rect x="35" y="74" width="30" height="7" rx="2" fill="#475569" />
    <path d="M44 64H56L54 75H46L44 64Z" fill="url(#goldGrad)" />
    {/* Cup Body */}
    <path d="M26 22H74C74 46 64 64 50 64C36 64 26 46 26 22Z" fill="url(#goldGrad)" />
    {/* Cup Rim */}
    <ellipse cx="50" cy="22" rx="24" ry="5" fill="url(#cupRimGrad)" />
    <ellipse cx="50" cy="22" rx="20" ry="3.5" fill="#D97706" />
    {/* Handles */}
    <path
      d="M26 28C16 28 12 39 17 48C21 54 27 53 29 51"
      stroke="url(#goldGrad)"
      strokeWidth="5"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M74 28C84 28 88 39 83 48C79 54 73 53 71 51"
      stroke="url(#goldGrad)"
      strokeWidth="5"
      strokeLinecap="round"
      fill="none"
    />
    {/* Sparkle Highlights */}
    <path d="M15 17L17 11L19 17L25 19L19 21L17 27L15 21L9 19L15 17Z" fill="#FBBF24" />
    <path d="M83 15L84.5 11L86 15L90 16.5L86 18L84.5 22L83 18L79 16.5L83 15Z" fill="#F59E0B" />
    <circle cx="21" cy="62" r="2.5" fill="#FCD34D" />
    <circle cx="80" cy="60" r="2" fill="#FBBF24" />
  </svg>
);

// 3D Certificate Vector Graphic
const CertificateIllustration = () => (
  <svg
    width="84"
    height="84"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="achievement-svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="certPaperGrad" x1="20" y1="15" x2="75" y2="85" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFBEB" />
        <stop offset="0.65" stopColor="#FEF08A" />
        <stop offset="1" stopColor="#FDE047" />
      </linearGradient>
      <linearGradient id="sealGrad" x1="56" y1="56" x2="76" y2="76" gradientUnits="userSpaceOnUse">
        <stop stopColor="#38BDF8" />
        <stop offset="1" stopColor="#0284C7" />
      </linearGradient>
      <linearGradient id="ribbonGrad" x1="58" y1="68" x2="78" y2="90" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F59E0B" />
        <stop offset="1" stopColor="#D97706" />
      </linearGradient>
    </defs>
    {/* Document Shadow */}
    <rect x="23" y="19" width="50" height="64" rx="5" fill="#CBD5E1" opacity="0.4" />
    {/* Parchment Body */}
    <rect x="20" y="16" width="50" height="64" rx="5" fill="url(#certPaperGrad)" stroke="#FACC15" strokeWidth="2" />
    {/* Inner Border / Lines */}
    <rect x="28" y="25" width="22" height="4" rx="2" fill="#3B82F6" />
    <rect x="28" y="33" width="34" height="3" rx="1.5" fill="#94A3B8" />
    <rect x="28" y="40" width="30" height="3" rx="1.5" fill="#94A3B8" />
    <rect x="28" y="47" width="34" height="3" rx="1.5" fill="#94A3B8" />
    <rect x="28" y="54" width="18" height="3" rx="1.5" fill="#CBD5E1" />
    {/* Ribbon Tails */}
    <path d="M62 70L58 86L64 82L70 86L66 70Z" fill="url(#ribbonGrad)" />
    {/* Blue Seal */}
    <circle cx="64" cy="65" r="10" fill="url(#sealGrad)" stroke="#FFFFFF" strokeWidth="2" />
    <path d="M60.5 65L63 67.5L67.5 62" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    {/* Sparkles */}
    <path d="M14 24L15.5 20L17 24L21 25.5L17 27L15.5 31L14 27L10 25.5L14 24Z" fill="#38BDF8" />
    <path d="M80 30L81.5 26L83 30L87 31.5L83 33L81.5 37L80 33L76 31.5L80 30Z" fill="#60A5FA" />
    <circle cx="81" cy="48" r="2.5" fill="#FBBF24" />
    <circle cx="15" cy="66" r="2" fill="#38BDF8" />
  </svg>
);

const About = () => {
  const [statsVisible, setStatsVisible] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 900, once: true });

    // Check prefers-reduced-motion
    if (typeof window !== 'undefined' && window.matchMedia) {
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      setPrefersReducedMotion(mediaQuery.matches);
    }

    // Viewport IntersectionObserver to trigger CountUp once
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStatsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-page">
      {/* =========================================================================
          HERO SECTION
          ========================================================================= */}
      <section className="about-hero-section" aria-label="About Hero">
        {/* Background decorative dots */}
        <div className="hero-decor-dots" aria-hidden="true"></div>

        {/* Left column: Intro, Name, Roles, Description & Animated Statistics */}
        <div className="about-hero-left" data-aos="fade-right">
          <div className="get-to-know-badge">
            <span className="badge-emoji">👋</span> GET TO KNOW ME
          </div>

          <h1 className="hero-greeting">
            Hi, I'm <br />
            <span className="hero-name-gradient">Praveen Kumar B</span>
          </h1>

          <h2 className="hero-roles-subtitle">
            Software Developer | Web Developer | Canva Designer | Freelancer
          </h2>

          <p className="hero-bio-paragraph">
            I'm a passionate Software Developer who loves building beautiful and functional websites.
            I specialize in front-end technologies and enjoy creating smooth user experiences. Apart
            from coding, I'm enthusiastic about learning new skills and pushing creative boundaries.
          </p>

          {/* Statistics Cards */}
          <div className="stats-cards-grid" ref={statsRef} aria-label="Key Statistics">
            {/* Card 1: Projects Completed */}
            <div className="stat-card">
              <div className="stat-icon-box icon-box-blue">
                <FaCode />
              </div>
              <div className="stat-content">
                <div className="stat-number">
                  {statsVisible ? (
                    prefersReducedMotion ? (
                      8
                    ) : (
                      <CountUp start={0} end={8} duration={2} preserveValue={true} />
                    )
                  ) : (
                    0
                  )}
                </div>
                <div className="stat-label">Projects Completed</div>
              </div>
            </div>

            {/* Card 2: Certificates */}
            <div className="stat-card">
              <div className="stat-icon-box icon-box-purple">
                <FaGraduationCap />
              </div>
              <div className="stat-content">
                <div className="stat-number">
                  {statsVisible ? (
                    prefersReducedMotion ? (
                      '20+'
                    ) : (
                      <CountUp start={0} end={20} duration={2} suffix="+" preserveValue={true} />
                    )
                  ) : (
                    0
                  )}
                </div>
                <div className="stat-label">Certificates</div>
              </div>
            </div>

            {/* Card 3: Awards Won */}
            <div className="stat-card">
              <div className="stat-icon-box icon-box-amber">
                <FaTrophy />
              </div>
              <div className="stat-content">
                <div className="stat-number">
                  {statsVisible ? (
                    prefersReducedMotion ? (
                      '5+'
                    ) : (
                      <CountUp start={0} end={5} duration={2} suffix="+" preserveValue={true} />
                    )
                  ) : (
                    0
                  )}
                </div>
                <div className="stat-label">Awards Won</div>
              </div>
            </div>

            {/* Card 4: Learning (Static value: Always) */}
            <div className="stat-card">
              <div className="stat-icon-box icon-box-cyan">
                <FaRocket />
              </div>
              <div className="stat-content">
                <div className="stat-number static-stat">Always</div>
                <div className="stat-label">Learning New Skills</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right column: Profile Photo with Orbit Badges & Availability */}
        <div className="about-hero-right" data-aos="fade-left">
          <div className="profile-orbit-wrapper">
            {/* Orbit Lines & Decorative Elements */}
            <div className="orbit-decor-canvas" aria-hidden="true">
              <div className="orbit-circle orbit-outer">
                <span className="orbit-dot dot-cyan"></span>
                <span className="orbit-dot dot-yellow"></span>
              </div>
              <div className="orbit-circle orbit-inner">
                <span className="orbit-dot dot-purple"></span>
                <span className="orbit-dot dot-blue"></span>
              </div>
            </div>

            {/* Profile circular frame */}
            <div className="profile-photo-circle">
              <img src={myPhoto} alt="Praveen Kumar B" className="profile-photo-img" />
            </div>

            {/* Floating Role Badges */}
            {/* 1. Frontend Developer (Top-Left) */}
            <div className="floating-badge badge-frontend-dev" title="Frontend Developer">
              <div className="badge-icon-box pink">
                <FaLaptopCode />
              </div>
              <div className="badge-text-group">
                <span className="badge-line-main">Frontend</span>
                <span className="badge-line-sub">Developer</span>
              </div>
            </div>

            {/* 2. Full Stack Developer (Mid-Left) - Replaces Web Developer */}
            <div className="floating-badge badge-fullstack-dev" title="Full Stack Developer">
              <div className="badge-icon-box blue">
                <FaGlobe />
              </div>
              <div className="badge-text-group">
                <span className="badge-line-main">Full Stack</span>
                <span className="badge-line-sub">Developer</span>
              </div>
            </div>

            {/* 3. Canva Designer (Bottom-Left) */}
            <div className="floating-badge badge-canva-designer" title="Canva Designer">
              <div className="badge-icon-box purple">
                <FaPalette />
              </div>
              <div className="badge-text-group">
                <span className="badge-line-main">Canva</span>
                <span className="badge-line-sub">Designer</span>
              </div>
            </div>

            {/* 4. Freelancer (Top-Right) */}
            <div className="floating-badge badge-freelancer" title="Freelancer">
              <div className="badge-icon-box orange">
                <FaBriefcase />
              </div>
              <div className="badge-text-group">
                <span className="badge-line-main">Freelancer</span>
              </div>
            </div>

            {/* 5. Problem Solver (Mid-Right) */}
            <div className="floating-badge badge-problem-solver" title="Problem Solver">
              <div className="badge-icon-box yellow">
                <FaLightbulb />
              </div>
              <div className="badge-text-group">
                <span className="badge-line-main">Problem</span>
                <span className="badge-line-sub">Solver</span>
              </div>
            </div>

            {/* 6. Creative Thinker (Bottom-Right) */}
            <div className="floating-badge badge-creative-thinker" title="Creative Thinker">
              <div className="badge-icon-box rose">
                <FaRocket />
              </div>
              <div className="badge-text-group">
                <span className="badge-line-main">Creative</span>
                <span className="badge-line-sub">Thinker</span>
              </div>
            </div>

            {/* Availability Indicator (Bottom Center of Photo) */}
            <div className="availability-pill-badge" title="Available for opportunities">
              <div className="pulse-indicator-circle">
                <span className="pulse-dot"></span>
                <span className="pulse-ring"></span>
              </div>
              <div className="availability-info">
                <span className="availability-heading">Available</span>
                <span className="availability-subtext">For Opportunities</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================================
          EDUCATION SECTION
          ========================================================================= */}
      <section className="about-education-section" data-aos="fade-up" aria-label="Education">
        {/* Education Header */}
        <div className="section-header-row">
          <div className="section-title-wrap">
            <div className="section-icon-badge badge-blue">
              <FaGraduationCap />
            </div>
            <div>
              <h2 className="section-heading-text">Education</h2>
              <p className="section-subtitle-text">My academic journey that shaped my career</p>
            </div>
          </div>

          {/* Action button connected to existing Resume page */}
          <Link to="/resume" className="view-timeline-btn">
            View Detailed Timeline <FaArrowRight className="btn-arrow-icon" />
          </Link>
        </div>

        {/* 5 Education Timeline Cards */}
        <div className="education-cards-grid">
          {/* Card 1: Bachelor's Degree (Completed Aug 2023 - May 2026) */}
          <div className="education-timeline-card card-accent-blue">
            <div className="edu-card-icon-wrap icon-blue">
              <FaGraduationCap />
            </div>
            <h3 className="edu-card-title">Bachelor's Degree</h3>
            <p className="edu-card-institution">
              Computer Science & Engineering - Dr.Mahalingam College Of Engineering & Technology.
            </p>
            <div className="edu-card-date">
              <FaCalendarDays className="calendar-icon" />
              <span>Aug 2023 - May 2026</span>
            </div>
            <div className="edu-card-badge-wrap">
              <span className="status-badge status-badge-green">
                <FaCheck className="check-icon" /> Completed
              </span>
            </div>
          </div>

          {/* Card 2: Diploma Degree */}
          <div className="education-timeline-card card-accent-purple">
            <div className="edu-card-icon-wrap icon-purple">
              <FaGraduationCap />
            </div>
            <h3 className="edu-card-title">Diploma Degree</h3>
            <p className="edu-card-institution">
              Computer Science & Engineering Nachimuthu Polytechnic College,Pollachi.
            </p>
            <div className="edu-card-date">
              <FaCalendarDays className="calendar-icon" />
              <span>Oct 2020 - May 2023</span>
            </div>
            <div className="edu-card-badge-wrap">
              <span className="status-badge status-badge-purple">
                <FaCheck className="check-icon" /> Completed
              </span>
            </div>
          </div>

          {/* Card 3: SSLC */}
          <div className="education-timeline-card card-accent-green">
            <div className="edu-card-icon-wrap icon-green">
              <FaBookOpen />
            </div>
            <h3 className="edu-card-title">SSLC</h3>
            <p className="edu-card-institution">Veveaham Matric Hr Sec School Dharapuram.</p>
            <div className="edu-card-date">
              <FaCalendarDays className="calendar-icon" />
              <span>2018 - 2019</span>
            </div>
            <div className="edu-sub-studied">Studied: 9th - 10th</div>
            <div className="edu-card-badge-wrap">
              <span className="status-badge status-badge-green">
                <FaCheck className="check-icon" /> Completed
              </span>
            </div>
          </div>

          {/* Card 4: School (RGM) */}
          <div className="education-timeline-card card-accent-orange">
            <div className="edu-card-icon-wrap icon-orange">
              <FaSchool />
            </div>
            <h3 className="edu-card-title">School</h3>
            <p className="edu-card-institution">RGM Matric Hr Sec School Pethappampatti.</p>
            <div className="edu-card-date">
              <FaCalendarDays className="calendar-icon" />
              <span>2014 - 2017</span>
            </div>
            <div className="edu-sub-studied">Studied: 5th - 8th</div>
            <div className="edu-card-badge-wrap">
              <span className="status-badge status-badge-orange">
                <FaCheck className="check-icon" /> Completed
              </span>
            </div>
          </div>

          {/* Card 5: School (Srinivasa) */}
          <div className="education-timeline-card card-accent-pink">
            <div className="edu-card-icon-wrap icon-pink">
              <FaBuildingColumns />
            </div>
            <h3 className="edu-card-title">School</h3>
            <p className="edu-card-institution">
              Srinivasa Vidyalaya Matric Hr Sec School, Udumalpet.
            </p>
            <div className="edu-card-date">
              <FaCalendarDays className="calendar-icon" />
              <span>2007 - 2013</span>
            </div>
            <div className="edu-sub-studied">Studied: Lkg - 4th</div>
            <div className="edu-card-badge-wrap">
              <span className="status-badge status-badge-pink">
                <FaCheck className="check-icon" /> Completed
              </span>
            </div>
          </div>
        </div>

        {/* Connected Horizontal Timeline Track with 5 Colored Nodes */}
        <div className="timeline-horizontal-track" aria-hidden="true">
          <div className="timeline-line-bar"></div>
          <div className="timeline-nodes-row">
            <div className="timeline-node-dot node-blue"></div>
            <div className="timeline-node-dot node-purple"></div>
            <div className="timeline-node-dot node-green"></div>
            <div className="timeline-node-dot node-orange"></div>
            <div className="timeline-node-dot node-pink"></div>
          </div>
        </div>
      </section>

      {/* =========================================================================
          BOTTOM SECTION: HOBBIES (LEFT) & MY ACHIEVEMENTS (RIGHT)
          ========================================================================= */}
      <div className="about-bottom-layout">
        {/* HOBBIES SECTION */}
        <section className="bottom-card-container hobbies-container" data-aos="fade-up">
          <div className="section-title-wrap bottom-header-wrap">
            <div className="section-icon-badge badge-rose">
              <FaHeart />
            </div>
            <div>
              <h2 className="section-heading-text">Hobbies</h2>
              <p className="section-subtitle-text">Things I love to do in my free time</p>
            </div>
          </div>

          <div className="hobbies-cards-grid">
            {/* Hobby 1: Coding */}
            <div className="hobby-card hobby-blue">
              <div className="hobby-icon-wrap icon-blue">
                <FaLaptopCode />
              </div>
              <h3 className="hobby-title">Coding</h3>
              <p className="hobby-desc">
                Love solving problems and building creative projects.
              </p>
            </div>

            {/* Hobby 2: Travelling */}
            <div className="hobby-card hobby-purple">
              <div className="hobby-icon-wrap icon-purple">
                <FaPlane />
              </div>
              <h3 className="hobby-title">Travelling</h3>
              <p className="hobby-desc">
                Exploring new places, cultures, and cuisines around the world.
              </p>
            </div>

            {/* Hobby 3: Reading Books */}
            <div className="hobby-card hobby-green">
              <div className="hobby-icon-wrap icon-green">
                <FaBookOpen />
              </div>
              <h3 className="hobby-title">Reading Books</h3>
              <p className="hobby-desc">
                Enjoy reading technology, personal growth, and fiction books.
              </p>
            </div>

            {/* Hobby 4: Listening to Music */}
            <div className="hobby-card hobby-orange">
              <div className="hobby-icon-wrap icon-orange">
                <FaMusic />
              </div>
              <h3 className="hobby-title">Listening to Music</h3>
              <p className="hobby-desc">
                Relaxing and getting inspired by various genres of music.
              </p>
            </div>
          </div>
        </section>

        {/* MY ACHIEVEMENTS SECTION */}
        <section className="bottom-card-container achievements-container" data-aos="fade-up" data-aos-delay="100">
          <div className="section-title-wrap bottom-header-wrap">
            <div className="section-icon-badge badge-amber">
              <FaTrophy />
            </div>
            <div>
              <h2 className="section-heading-text">My Achievements</h2>
              <p className="section-subtitle-text">Recognition and certifications in my journey</p>
            </div>
          </div>

          <div className="achievements-cards-row">
            {/* Card A: Awards Won (NO button) */}
            <div className="achievement-item-card awards-card">
              <div className="achievement-visual">
                <TrophyIllustration />
              </div>
              <div className="achievement-details">
                <h3 className="achievement-type-title">Awards Won</h3>
                <div className="achievement-number number-magenta">5+</div>
                <p className="achievement-subtext">Awards & Recognitions</p>
              </div>
            </div>

            {/* Card B: Certificates (ONLY button in My Achievements) */}
            <div className="achievement-item-card certificates-card">
              <div className="achievement-visual">
                <CertificateIllustration />
              </div>
              <div className="achievement-details">
                <h3 className="achievement-type-title">Certificates</h3>
                <div className="achievement-number number-blue">20+</div>
                <p className="achievement-subtext">Professional Certificates</p>
                <Link to="/certificates" className="achievement-action-btn">
                  View My Certificates <FaArrowRight className="btn-arrow-icon" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
